import React, { useEffect, useState } from "react";
import axios from "axios";
import { API } from "../App";
import { Plus, Trash2, Save, Calendar } from "lucide-react";

const DAYS = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];

export default function VetAvailability() {
  const [windows, setWindows] = useState([]);
  const [closedDates, setClosedDates] = useState([]);
  const [newDate, setNewDate] = useState("");
  const [saving, setSaving] = useState(false);
  const [saved, setSaved] = useState(false);

  useEffect(() => {
    axios.get(`${API}/partner/vet/availability`).then(r => {
      const a = r.data.availability || {};
      setWindows(a.windows || []);
      setClosedDates(a.closed_dates || []);
    });
  }, []);

  const addWindow = () => setWindows(w => [...w, { day_of_week: 0, start: "10:00", end: "13:00", slot_minutes: 20 }]);
  const remove = (i) => setWindows(w => w.filter((_, idx) => idx !== i));
  const updateWin = (i, k, v) => setWindows(w => w.map((x, idx) => idx === i ? { ...x, [k]: v } : x));
  const addClosed = () => { if (newDate && !closedDates.includes(newDate)) { setClosedDates([...closedDates, newDate]); setNewDate(""); } };
  const removeClosed = (d) => setClosedDates(closedDates.filter(x => x !== d));

  const save = async () => {
    setSaving(true);
    await axios.put(`${API}/partner/vet/availability`, { windows, closed_dates: closedDates });
    setSaving(false); setSaved(true);
    setTimeout(() => setSaved(false), 2000);
  };

  return (
    <div className="space-y-6" data-testid="vet-availability-page">
      <header className="flex items-start justify-between flex-wrap gap-3">
        <div>
          <div className="text-xs uppercase tracking-[0.2em] text-brand font-bold">My Clinic</div>
          <h1 className="font-heading text-3xl font-extrabold mt-1">Booking Slots</h1>
          <p className="text-ink-soft text-sm">Define when you're available. Pet parents can only book real-time open slots.</p>
        </div>
        <button onClick={save} data-testid="save-availability" className="bg-brand text-white rounded-full px-5 py-2.5 text-sm font-bold inline-flex items-center gap-1.5">
          <Save className="w-4 h-4"/> {saving ? "Saving…" : saved ? "Saved ✓" : "Save"}
        </button>
      </header>

      <section className="bg-surface border border-line rounded-3xl p-5">
        <div className="flex items-center justify-between mb-3">
          <h2 className="font-heading text-lg font-extrabold">Weekly availability</h2>
          <button onClick={addWindow} data-testid="add-window" className="bg-ink text-white rounded-full px-3 py-1.5 text-xs font-bold inline-flex items-center gap-1"><Plus className="w-3 h-3"/> Add slot block</button>
        </div>
        <div className="space-y-2">
          {windows.map((w, i) => (
            <div key={i} data-testid={`window-${i}`} className="grid grid-cols-12 items-center gap-2 bg-surface-muted/50 rounded-2xl p-3">
              <select value={w.day_of_week} onChange={e => updateWin(i, "day_of_week", Number(e.target.value))} className="col-span-3 inp">
                {DAYS.map((d, idx) => <option key={idx} value={idx}>{d}</option>)}
              </select>
              <input type="time" value={w.start} onChange={e => updateWin(i, "start", e.target.value)} className="col-span-3 inp"/>
              <input type="time" value={w.end} onChange={e => updateWin(i, "end", e.target.value)} className="col-span-3 inp"/>
              <div className="col-span-2 flex items-center gap-1">
                <input type="number" min="5" max="120" value={w.slot_minutes} onChange={e => updateWin(i, "slot_minutes", Number(e.target.value))} className="inp text-center"/>
                <span className="text-[10px] text-ink-soft font-bold">min</span>
              </div>
              <button onClick={() => remove(i)} className="col-span-1 justify-self-end text-ink-soft hover:text-brand"><Trash2 className="w-4 h-4"/></button>
            </div>
          ))}
          {windows.length === 0 && <div className="text-sm text-ink-soft text-center py-6">No slots yet — click "Add slot block" to define your weekly schedule.</div>}
        </div>
      </section>

      <section className="bg-surface border border-line rounded-3xl p-5">
        <h2 className="font-heading text-lg font-extrabold mb-3"><Calendar className="inline w-5 h-5 -mt-1"/> Closed dates (holidays)</h2>
        <div className="flex gap-2 mb-3">
          <input type="date" value={newDate} onChange={e => setNewDate(e.target.value)} className="inp" data-testid="closed-date-input"/>
          <button onClick={addClosed} className="bg-ink text-white rounded-full px-4 py-2 text-sm font-bold">Block date</button>
        </div>
        <div className="flex flex-wrap gap-2">
          {closedDates.map(d => (
            <span key={d} className="inline-flex items-center gap-1.5 bg-surface-muted rounded-full px-3 py-1 text-xs font-bold">
              {d} <button onClick={() => removeClosed(d)}><Trash2 className="w-3 h-3"/></button>
            </span>
          ))}
        </div>
      </section>
      <style>{`.inp{border:1px solid #EAE0D5;border-radius:14px;padding:0.5rem 0.9rem;background:#FFFDF7;font-family:'Nunito';font-weight:600;outline:none;}.inp:focus{border-color:#FF6B35;}`}</style>
    </div>
  );
}
